import { Component, inject, input, signal } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DropdownComponent } from '../../dropdown-component/dropdown-component';
import { Downtime } from '../../../../core/services/times/downtime';
import { environmenProgress } from '../../../../../environments/environment.progress';
import { TranslatePipe } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';

interface IPlayer {
		player_id: number,
		name: string,
		gender_name: string,
		gender_icon: string,
		gender_id: number,
		is_starter: boolean,
		is_ready: boolean,
		is_newbie: boolean,
		rq_id: number,
		position: number | null,
		dice_sum: number | null,
		dice_value: number | null,
		last_activity: number | null,
    quest_list?: Array<number>,
    role_icon?: string,
    successesInGame?: number,
    points?: number,
    maxPoints?: number,
		created: number,
    [propName: string]: any
}

@Component({
  selector: 'app-tmp-player',
  imports: [MatTooltipModule,MatProgressBarModule,DropdownComponent, TranslatePipe, DecimalPipe],
  templateUrl: './tmp-player.html',
  styleUrl: './tmp-player.scss'
})
export class TmpPlayer {
  player = input<IPlayer>();
  idx = input<number>(0);
  turning = input<number>(0);
  downtime = inject(Downtime);
  isOpenDropdown = signal<boolean>(false);

  setProgress = environmenProgress;

  showPlayerInfo(): void {
    this.downtime.refreshTimer();
    this.isOpenDropdown.update(value => !value);
  }

  yourTxtRating(interest: number){
    let txt = 'txtEmpty';

    this.setProgress.ratings.forEach((item:any) => {
      if(item.valueB <= interest && interest <= item.valueE){
        txt = item.langT;
      }
    });

    return txt;
  }

  teamRaceResult(idx: number, allpoints:number = 0):string{
    let txtResult = "";
    if(allpoints > 0){
      switch(idx){
        case 1: txtResult = "plr-first";break;
        case 2: txtResult = "plr-second";break;
        case 3: txtResult = "plr-third";break;
        default: txtResult = "";break;
      }
    }
    return txtResult;
  }

  isTurning(player_id: number = 0):boolean{
    let is_activ = false;
    if(player_id === (this.turning() as number)){
      is_activ = true;
    }
    return is_activ;
  }

  isPoints(points:number = 0):boolean{
    let show: boolean = false;
    if(points > 0){
      show = true;
    }
    return show;
  }

  isYouPrayer(playerId: number = 0):boolean{
    let isYou: boolean = false;
    const pl:IPlayer = JSON.parse(sessionStorage.getItem("player") as string);
    if(pl.player_id === playerId){
      isYou = true;
    }
    return isYou;
  }

}
